export enum DropdownType {
  Date,
  Profile,
  State
}
